import { render, staticRenderFns } from "./PostTableComponent.vue?vue&type=template&id=5b54dcd2&"
import script from "./PostTableComponent.vue?vue&type=script&lang=js&"
export * from "./PostTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports